import { isCompleted } from './index';
import { handleElectronicConsentExpirationTime } from './handleTaskTime';

const getElectronicConsentHeaderRenderData = (entity, formatMessage) => {
  const {
    completedTime,
    expiredTime,
    todoStatus,
    assigneeUser: { id: userId },
    assignerUser,
    consent: {
      consentType: { name: consentTypeName },
      content,
      id: consentId,
      multipleOutcomes,
      name: consentName,
      organization: { name: organizationName },
      outcomeTitles,
    },
    id,
    version,
  } = entity;

  const { displayableName: assignedBy } = { ...assignerUser };

  const time = isCompleted(todoStatus) ? completedTime : expiredTime;

  const formatTime = handleElectronicConsentExpirationTime(
    time,
    formatMessage,
    isCompleted(todoStatus),
  );

  return {
    assignedBy,
    consentId,
    consentName,
    consentTypeName,
    consentVersionTitle: formatMessage({ id: 'common.version' }),
    content,
    formatTime,
    id,
    organizationName,
    userId,
    version,
    multipleOutcomes,
    outcomeTitles,
  };
};

export default getElectronicConsentHeaderRenderData;



// WEBPACK FOOTER //
// ./src/components/Healthboard/utils/getElectronicConsentHeaderRenderData.js